import TagManager from './TagManager';
export default TagManager;

export * from './TagManager';
